import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import * as z from 'zod'
import { getAnnualReviewDetails } from '~bank-annual-review/service'

const sch = z.object({
  historyPage: z.number().int().positive().optional(),
  historySize: z.number().int().positive().optional()
})

export const annualReviewDetailsRoute = <T extends AnyRoute>(indexRoute: T) => {
  const route = createRoute({
    getParentRoute: () => indexRoute,
    path: 'detail'
  })

  const detailsRoute = createRoute({
    getParentRoute: () => route,
    path: '$companyId/$id',
    validateSearch: (search: Record<string, unknown>) => sch.parse(search),
    loaderDeps: ({ search: { historyPage, historySize } }) => ({ historyPage, historySize }),
    beforeLoad: ({ params }) => {
      if ('id' in params && params.id && Number(params.id)) return { id: Number(params.id) }
      else throw new NotFoundError()
    },
    loader: ({ context: { id }, deps }) => {
      if (id)
        return getAnnualReviewDetails({
          id: Number(id),
          historyPage: deps.historyPage,
          historySize: deps.historySize
        })
      else throw new NotFoundError()
    },
    component: lazyRouteComponent(() => import('./AnnualReviewDetails'))
  })

  const printRoute = createRoute({
    getParentRoute: () => route,
    path: '$companyId/$id/print',
    loaderDeps: ({ search: { historyPage, historySize } }) => ({ historyPage, historySize }),
    beforeLoad: ({ params }) => {
      if ('id' in params && params.id && Number(params.id)) return { id: Number(params.id) }
      else throw new NotFoundError()
    },
    loader: ({ context: { id }, deps }) => {
      if (id)
        return getAnnualReviewDetails({
          id: Number(id),
          historyPage: deps.historyPage,
          historySize: deps.historySize
        })
      else throw new NotFoundError()
    },
    component: lazyRouteComponent(() => import('./components/AnnualReviewPrint/AnnualReviewPrint'))
  })

  return route.addChildren([printRoute, detailsRoute])
}
